import {Row,Col,Card, Container} from "react-bootstrap"
import {Link} from "react-router-dom"
const RaspberryRipples = () =>{
    return <div style={{padding:"2%"}}>   
    <h1>Raspberry Ripples VCFA</h1>
    <p>A whipped up remix if Mutable Instruments Ripples which emphasises exploring experimental flavours.</p>
    <p>
It provides all 4 low pass filter poles, the clean signal mixed with resonance, and control over the resonance compensation circuit.
    </p>
    <p>
      If you're a total nerd then you know that this allows you participate in pole mixing to mix stages and produce all sorts of filter responses.
       If you are not a nerd but still want more then check out <a href="/Flake">Flake</a> which does the hard work for you to generate (a)typical responses and a phaser!
    </p>

    <ul className="flex-container">
    <li className = "flex-item" style={{width:"40rem"}}>


    <h3>Features</h3>
    <p>4-pole low pass VCF with Wide frequency range down to 20Hz.</p>
    <p>V/Oct and attenuverting FM CV control</p>
    <p>Pre-filter VCA with configurable gain and soft clipping. Offset control attenuates CV when patched in.</p>
    <p>Voltage controlled resonance which welcomes self oscillation.</p>
    <p>  
      Configurable resonance compensation modes from Ripples liquid sound, traditional sounds, weird sounds, and onwards into chaos...
    </p> 
    <p>Outputs for each pole of the low pass filter core (6,12,18,24 dB/Octave slopes) and output for the post-VCA unfiltered signal mixed with only the resonance (denoted as 0dB).
       I've found this "single-band resonator" circuit works wonders on drums!</p>
    <p>When self-oscillating the four outputs can be treated like a 4-quadrant V/Oct Oscillator (specifically 0, 270, 180, 90 degrees)</p>
    <p>All Outputs are actively buffered and have a nice and low 1k ohm output impedance</p>

    <h3>Specs</h3>
    <p>Width: 8HP (40.64mm)</p>
    <p>height: 3U (128.5mm)</p>
    <p>depth: ~40mm </p>
    <p>+12V: ~50mA (TBC)</p>
    <p>-12V: ~50mA (TBC)</p>


<h3>How to use</h3>
<p>
This module has 1 audio input and CV controls for cutoff (V/Oct and FM), VCA Level, and Resonance.</p>
<p>
The VCA is applied to the input before being filtered so it applies to all outputs evenly.
This clean signal has it’s own output mixed with resonance for fun and pole mixing. 
When a VCA CV is patched in, the offset knob becomes a CV attenuator.
</p>
The signal is then sent to the filter unit where all 4 stages of the filter have their own respective outputs (1,2,3, and 4 pole low pass).
<p>
Cutoff freqeuncy is controlled by the frequency knob, V/Oct CV, and FM CV which is attenuverted by the FM knob.
</p>
<p>
Resonance is dialled in with the respective knob and CV input. It should self-oscillate around 4V. 
</p>
<p>
A patch point allows you to change the flavour of the filter by hijacking the q-compensation circuit.
<br></br>
<br></br>
<p><b>The resonance (q) compensation patch point:</b></p>
Filters can alter their resonance characteristics by mixing some signal into the feedback path. 
The original Ripples lovely sound comes from subtracting the clean signal in the feedback path - this compensates for the loudness drop input signal as resonance increases and emphasises bass.
</p>
<p>
This module provides a jack input for you to subtract anything you want from the feedback signal. 
by default, the input is normalled to the clean signal for the classic liquid sounds.
</p>
<p>
Patching a jack in and leaving it hanging (or grounded) removes all compensation for a classic filter sound.
Self patching one of the filter stage inputs creates all sorts chaos for all sorts of reasons. 
There is nothing stopping you from patching in whatever you want. Anything related to the input signal is likely to create something special! It's entirely your fault. I've found using another output of your oscillator to be fun!
</p>
<p>
<p>With <a href ="/Flake">Flake</a>, the pole mixing expander we provide 9 additional filter responses including a double notchpass and phaser which you could mix back into the feedback path in to create even wilder results!</p>
</p>

<h3>Recipes</h3>
<p>Plug the first pole into FM input to get a wobbly sound as described by the 4-pole mission filter of the wonderful shruthi</p>

<p>Pair the outputs with CAVIAR or CAV to pole mix yourself and modulate between modes.
   Try crossfading 0dB and 6dB pole output for high pass and 6dB and 12dB for band pass!</p>

<h3>Mods</h3>
<p>The filter is configured to give a nice clean resonance to emphasise exploring compensation. If you want some more character I've left a couple solder points between the input and output of the feedback amplifier for you to insert some flavour.
   Try some zeners to soft clip the resonance, prevent self-oscillation, or make it scream!</p>

<h3>Media:</h3>
  <a href = "https://youtu.be/KhuFQRKqOTs">Flake + Ripples</a>
  <br></br>
  <a href = "https://youtu.be/D-8aYTKa7ag?si=mhvp7rvsqjNwLjmD">First Prototype Demo</a>
<br></br>
<br></br>
<h3>DIY</h3>
<p>If you have a diy kit then check out <a href="/RaspberryRipples/Build">the DIY guide</a></p>

</li>
<li className = "flex-item" style={{width:"20rem"}}>
  <img src={require("./Raspberry Ripples.jpg")} style={{width:"100%"}}></img>
</li>
</ul>



    </div>


}



export default RaspberryRipples